module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B095L8YNFF.38235287.jpg";